import { useNavigate } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
import { ICustomColumn, IPageProps } from 'types'
import { AddButton, PageHeader } from 'components'
import { V1ApiDealersClient } from 'core/http-common'
import toast from 'core/toast'
import { DeletedStateEnum } from '@v1DealersApi'
import SAGrid, { GridGetDataProps, GetDataResponse } from 'components/Grid/SAGrid'
import { GridRowClickEvent } from '@progress/kendo-react-grid'

export interface IDropDownStringValue {
    id: string,
    text: string
}

const DealersPage = ({ title }: IPageProps) => {

    const navigate = useNavigate()

    const dealerColumns: ICustomColumn[] = [
        { field: 'dealerId', title: 'Dealer ID' },
        { field: 'dealerName', title: 'Dealer Name' },
        { field: 'address1', title: 'Address 1' },
        { field: 'address2', title: 'Address 2' },
        { field: 'city', title: 'City' },
        { field: 'state', title: 'State' },
        { field: 'zip', title: 'Zip' },
    ]

    const fetch = async (props: GridGetDataProps): Promise<GetDataResponse> => {
        try {
            const result = await V1ApiDealersClient.getAllDealers(
                DeletedStateEnum.Active,
                '',
                undefined,
                undefined,
                props.paging && props.paging.currentPage ? props.paging.currentPage : 1,
                props.paging ? props.paging.take : 10,
            )
            return {
                data: result.data,
                total: result.totalItems ? result.totalItems : 0
            }
        }
        catch (e) {
            toast.responseErrors(e)
            return {
                data: [],
                total: 0
            }

        }
    }

    return (
        <div id='DealersPage'>
            <PageHeader title={title}>
                <AddButton className='btn-lg btn-primary btnWidth mb-2 mb-md-0' onClick={() => navigate('/dealers/add')}>
                    Add Dealer
                </AddButton>
            </PageHeader>

            <Row>
                <Col>
                    <SAGrid
                        features={
                            {
                                pageable: true,
                                reorderColumns: true
                            }
                        }
                        columns={dealerColumns}
                        defaultSort={[{ field: 'dealerId', dir: 'asc' }]}
                        getData={fetch}
                        onRowClick={(e: GridRowClickEvent) => navigate(`/dealers/edit/${e.dataItem.dealerId}`)}
                    />
                </Col>
            </Row>
        </div>
    )
}
export default DealersPage

